import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { EcouiProvider } from "ecologital-ui-library";
import reportWebVitals from "./reportWebVitals";
import "ecologital-ui-library/dist/ecologitalUILibrary.css";
// Last import wins for equal specificity, so this sits after the UI library
// to reach the scrollbars inside its components too.
import "./styles/scrollbars.css";
import initScrollAutoHide from "./utils/scrollAutoHide";
import initDragToScroll from "./utils/dragToScroll";

initScrollAutoHide();
// Grab-and-pan for the scroll regions, now that no bar is drawn at rest.
initDragToScroll();

ReactDOM.render(
  <React.StrictMode>
    <EcouiProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </EcouiProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

if (process.env.NODE_ENV !== "development") console.log = () => {};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
